import { Component, OnInit, QueryList } from '@angular/core';
import { CopyService } from './../../shared/services/copies/copy.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';

import { FormBuilder, FormGroup } from '@angular/forms';
import { CatalogService } from './../../shared/services/catalogs/catalog.service';
import { VclSnackBarService } from '@voxel/community';
import { ISolicitation, IRequestSolicitationResponse } from './../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { centerDialog, findInArray, getValueProperty as getValue, getValueProperty, scrollBottom, scrollTop, setValueProperty } from '../../shared/helpers/functions.helpers';
import { FileService } from './../../shared/services/onbase/file-service.service';
import { EDocumentTypeId } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { ApplicationService } from '../../shared/services/application/application.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { BaseComponent } from '../../shared/components/base-component';
import { EVENT } from '../../shared/constants/dali.constants';
import { camelCase } from 'lodash';

export enum ESection {
    BASIC = "basic_data",
    CONTACTS = "contacts_data",
    ADDITIONAL = "additional_data"
}

export enum EActionModal {
    CANCEL = 'action1',
    OK = 'action2'
}

@Component({
    selector: 'app-solicitation-detail',
    templateUrl: './solicitation-detail.component.html',
    styleUrls: ['./solicitation-detail.component.scss']
})
export class SolicitationDetailComponent extends BaseComponent implements OnInit {

    form: FormGroup = this.fb.group({
        basic_data: this.fb.group({}),
        contacts_data: this.fb.group({}),
        additional_data: this.fb.group({})
    });

    CONTENT_BOUNDS: any[] | any;

    stepsList: string[] = [];
    documentTypeList: any[] = [];
    citiesList: any[] = [];
    departmentList: any[] = [];

    options: Array<{ label: string, value: any, disabled: boolean }> = [{
        label: "prueba",
        value: 1,
        disabled: false
    }];

    displayedColumnsInformation: string[] = [
        'date',
        'type',
        'subtype',
        'document',
        'value'
    ];

    additionalData: {
        date: string,
        type: string,
        subtype: string,
        document: string,
        value: number,
    }[] = [];

    displayedColumnsContacts: string[] = [
        'fullname',
        'phone_1',
        //'phone_2',
        'state',
        'city',
        'email'
    ];

    isEditSectionBasicData = false;
    isEditSectionContactsData = false;
    isEditSectionInformationData = false;

    modalEditShow = false;
    modalDeleteShow = false;

    ACTION_MODAL = EActionModal;
    SECTIONS = ESection;

    readonly ID_TYPE_DOCUMENT_NIT = EDocumentTypeId.NIT;

    /**
     *
     */
    buttonLabels: any = {};

    /**
     * Almacena los datos digitados por el cliente en pasos anteriores
     */
    solicitationData: ISolicitation = {};

    /**
     *
     */
    showDialogConfirm = false;

    segmentList: Array<{ name: string, id: any, subsegments: Array<any> }> = [];

    subsegmentList: Array<{ name: string, id: any, segmentId: any }> = [];

    economicActivityList: Array<{ name: string, id: any }> = [];

    showErrorMessage = false;

    isLoading = false;
    processResponse: boolean = false;

    processed: any | undefined = undefined;

    genderList: QueryList<any> | any = [];
    //genderList: QueryList<any> | any = {} as QueryList<any>;
    not_preset_gender: any;
    customer_type_nonimply: any;
    customerDisplaygender: any;

    customerTypesList: any[] = [];
    celulaTypesList: any[] = [];
    celulaSubtypesList: any[] = [];

    /**
     * Constructor de la clase SolicitationDetailComponent
     * @param _solicitation
     * @param cps
     * @param fb
     * @param _catalog
     * @param vclSnackBarService
     */
    constructor(
        private readonly _solicitation: RequestSolicitationsService,
        private readonly cps: CopyService,
        private readonly fb: FormBuilder,
        private readonly _catalog: CatalogService,
        private readonly _file: FileService,
        private readonly vclSnackBarService: VclSnackBarService,
        public app: ApplicationService,
        private link: LinkupService
    ) {
        super(app, link, 'solicitation-detail');
    }

    /**
    * Inicializamos variables y objetos de la clase
    */
    ngOnInit(): void {
        this.buttonLabels = {};
        this.buttonLabels[this.ACTION_MODAL.CANCEL] = 'Cancelar';
        this.buttonLabels[this.ACTION_MODAL.OK] = 'Aceptar';
        this.loadStaticValues().finally(() => {
            super.onLoad();
        });
        this.loadData();
    }

    /**
     * Permite la carga de textos y listas estaticas
     */
    async loadStaticValues() {
        await super.loadStaticValues();
        this.CONTENT_BOUNDS = await this.cps.getCopy("solicitation-detail");
        this.stepsList = await this.cps.getCopy("stepList");
        this.citiesList = await this._catalog.cities;
        this.documentTypeList = await this._catalog.documentTypes;
        this.departmentList = await this._catalog.states;
        this.segmentList = await this._catalog.segments;
        this.subsegmentList = await this._catalog.getSubsegments();
        this.economicActivityList = await this._catalog.economicActivities;
        this.genderList = await this._catalog.genders;
        this.customerTypesList = await this._catalog.customerTypes;
        this.celulaTypesList = await this._catalog.getCelulaTypes();
    }
    /**
     * Permite cargar la información proveniente de los pasos anteriores
   */
    async loadData() {
        this.additionalData = [];
        this.solicitationData = this._solicitation.solicitation;
        const type = this.getValueProperty(this.solicitationData, 'additionalData.SolicitationType');
        const subtype = this.getValueProperty(this.solicitationData, 'additionalData.SolicitationSubtype')
        if (type && subtype) {
            const cellId = this.getValueProperty(this.solicitationData, 'additionalData.Cell.id');
            this.celulaSubtypesList = await this._catalog.getCelulaTypeSubtypes(cellId, type);
        }
    }

    /**
     * Encargado de controlar la navegación en el componente
     * @param start
     */
    async navigateTo(start: any) {
        if (start === "next") {
            let eventSetting = this.getSetting("analytics", "trackEvent.e1", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E1setData.pv5E1transactionName.path}",
                    "value": EVENT.pv5E1setData.pv5E1transactionName.value
                },
                {
                    "name": "{EVENT.pv5E1setData.pv5E1transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            this.onEvent(eventSetting);
            this.showDialogConfirm = true;
            centerDialog();
        }
        else {
            let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E2setData.pv5E2transactionName.path}",
                    "value": EVENT.pv5E2setData.pv5E2transactionName.value
                },
                {
                    "name": "{EVENT.pv5E2setData.pv5E2transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            this.onEvent(eventSetting);
            await this._solicitation.navigation.previousStep();
        }
    }

    /**
     * Controla el evento de salida principal
     * @param $event
     */
    onCloseEvent($event: any) {
        console.log('close event', $event);
    }

    /**
     * Permite habilitar la edición de los datos de las diferentes secciones
     * @param section
     */
    editSection(section: ESection) {

        if (section === ESection.BASIC) {
            this.isEditSectionBasicData = true;
            /** Guardar valores iniciales, en caso de cancelar restaurar valores */
        } else if (section === ESection.CONTACTS) {
            this.isEditSectionContactsData = true;
            /** Guardar valores iniciales, en caso de cancelar restaurar valores */
        } else if (section === ESection.ADDITIONAL) {
            this.isEditSectionInformationData = true;
        } else {
            console.log('Section not found', section);
        }

    }

    /**
     * Permite obtener la instancia del formulario para la información basica del cliente
     */
    get basicDataForm(): FormGroup {
        return this.form.get('basic_data') as FormGroup;
    }

    /**
     * Permite obtener la instancia del formulario para la información de contactos del cliente
     */
    get contactsDataForm(): FormGroup {
        return this.form.get('contacts_data') as FormGroup;
    }

    /**
     * Permite obtener la instancia del formulario para la información adicional del cliente
     */
    get additionalDataForm(): FormGroup {
        return this.form.get('additional_data') as FormGroup;
    }

    /**
     * Permite obtener la sección activa para la edición
     */
    get sectionActive() {
        if (this.isEditSectionBasicData) {
            return ESection.BASIC;
        } else if (this.isEditSectionContactsData) {
            return ESection.CONTACTS;
        } else if (this.isEditSectionInformationData) {
            return ESection.ADDITIONAL;
        } else {
            return null;
        }
    }

    /**
     * Permite cancelar la edición de una sección y restaurar los datos en memoria
     */
    onCancelAction() {
        if (this.sectionActive === ESection.BASIC) {
            this.isEditSectionBasicData = false;
        } else if (this.sectionActive === ESection.CONTACTS) {
            this.isEditSectionContactsData = false;
        } else if (this.sectionActive === ESection.ADDITIONAL) {
            this.isEditSectionInformationData = false;
        }
        /** Restaurar valores iniciales */
    }

    /**
     * Permite guardar los datos de la sección activa
     */
    onSaveAction() {
        if (this.sectionActive === ESection.BASIC) {
            this.solicitationData.basicData = this.basicDataForm.value;
            this.isEditSectionBasicData = false;
        } else if (this.sectionActive === ESection.CONTACTS) {
            this.solicitationData.contactsData = this.contactsDataForm.value;
            this.isEditSectionContactsData = false;
        } else if (this.sectionActive === ESection.ADDITIONAL) {
            this.solicitationData.contactsData = this.contactsDataForm.value;
            this.isEditSectionInformationData = false;
        }

        const snackbarText = this.getValueProperty(this.CONTENT_BOUNDS, 'snackbar_text');
        this.vclSnackBarService.open(this.getValueProperty(snackbarText, 'save_data'), undefined, undefined, { duration: 3000 });

    }

    /**
     * Permite obtener el valor de una propiedad del objeto pasado por parametro
     * @param object
     * @param property
     */
    getValueProperty(object: any, property: string | number, defecto?: any) {
        return getValue(object, property, defecto);
    }

    /**
    * Permite capturar la respuesta del usuario y continuar el proceso segun la acción realizada
    * @param event
    */
    async dialogButtonClicked(event: any) {
        this.showDialogConfirm = false;
        if (event.type === this.ACTION_MODAL.OK) {
            let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionProductDetails.path}",
                    "value": this.solicitationData.analyticsData?.customer_type
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3clientElegibility.path}",
                    "value": this.solicitationData.analyticsData?.solicitation_type
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionTransactionInstitution.path}",
                    "value": this.solicitationData.analyticsData?.solicitation_cell
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionName.path}",
                    "value": EVENT.pv5E3setData.pv5E3transactionName.value
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            setValueProperty(eventSetting, "messageEvent", this.solicitationData.analyticsData?.solicitation_subtype);
            let word = camelCase(getValueProperty(this.solicitationData, "additionalData.Annotations", ""));
            if (word) {
                word = word[0].toUpperCase() + word.substring(1);
            }
            setValueProperty(eventSetting, "searchTerm", word);
            this.onEvent(eventSetting);

            this.isLoading = true;
            this.customerDisplaygender =
                getValue(this.solicitationData, 'basicData.gender') !==
                this.CONTENT_BOUNDS.sections.basic_data.controls.gender.not_implies_gender;
            this.customer_type_nonimply = getValue(this.CONTENT_BOUNDS, 'sections.basic_data.controls.gender.customer_type_nonimply');
            this.not_preset_gender = getValue(this.solicitationData, 'additionalData.CustomerTypes') == this.customer_type_nonimply ?
                this.CONTENT_BOUNDS.sections.basic_data.controls.gender.not_implies_gender : this.CONTENT_BOUNDS.sections.basic_data.controls.gender.not_preset_gender;

            this._solicitation.not_preset_gender = this.not_preset_gender;
            const documentNumber = getValue(this.solicitationData.basicData, 'document_number', '');
            const documentType = getValue(this.solicitationData.basicData, 'document_type', '');
            const buildData = await this._solicitation.buildData(this.solicitationData);

            console.log('buildData', buildData);

            const responseRequest = await this._solicitation.send(buildData, documentType, documentNumber);
            
            console.log('responseRequest', responseRequest);

            if (responseRequest.hasOwnProperty('data') && getValue(responseRequest, 'data.solicitation.solicitation_id', false)) {
                const isProcessDocuments = await this.processDocuments(responseRequest as IRequestSolicitationResponse);
                setValueProperty(this._solicitation.solicitation, "additionalData.errorUpload", !isProcessDocuments);
                this._solicitation.navigation.nextStep();
            }
            else {
                let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
                let pageSetting = this.getSetting("analytics", "pageLoad", "");
                let events = [
                    {
                        "name": "{EVENT.pv5E5setData.pv5E5transactionName.path}",
                        "value": EVENT.pv5E5setData.pv5E5transactionName.value
                    },
                    {
                        "name": "{EVENT.pv5E5setData.pv5E5transactionProductCategory.path}",
                        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                    }
                ];
                setValueProperty(eventSetting, "events", events);
                setValueProperty(eventSetting, "messageEvent", this.getValueProperty(responseRequest, "numberTrys", 1));
                let word = camelCase(this.getValueProperty(responseRequest, "message", ""));
                word = word[0].toUpperCase() + word.substring(1);
                setValueProperty(eventSetting, "errorName", this.getValueProperty(responseRequest, "code", "NO_RESPONSE") + " | " + word);
                this.onEvent(eventSetting);
            }
            this.isLoading = false;
            this.showErrorMessage = true;
            scrollTop();
        }
        else if (event.type === this.ACTION_MODAL.CANCEL) {
            let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E4setData.pv5E4transactionName.path}",
                    "value": EVENT.pv5E4setData.pv5E4transactionName.value
                },
                {
                    "name": "{EVENT.pv5E4setData.pv5E4transactionProductCategory.path}",
                    "value":  getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            this.onEvent(eventSetting);
            scrollBottom();
        }

    }

    /**
     * Permite conocer si el cliente cargado existe en phoenix
     */
    get customerExists(): boolean {
        return getValue(getValue(this.solicitationData, 'basicData'), 'customer_exists', false);
    }

    /**
     * Permite conocer si el cliente cargado es persona juridica
     */
    get isJuridicPerson(): boolean {
        let idDocumentType = getValue(getValue(this.solicitationData, 'basicData'), 'document_type', false);
        return idDocumentType === this.ID_TYPE_DOCUMENT_NIT;
    }

    /**
     * @todo Implementar funcionalidad
     * @param responseRequest
     */
    async processDocuments(responseRequest: IRequestSolicitationResponse): Promise<boolean> {
        /**
         * @todo Validar cuando no se cargan soportes, debe permitir la radicación
         **/
        this.processResponse = true;
        try {
            /**
             *  Incluir logica de cargue documetal
             */
            if (getValue(responseRequest, 'data.solicitation.solicitation_id', false)) {
                const fileData = await this._file.buildData(this._solicitation.solicitation);
                await this._file.send(fileData);
            }
            else {
                throw "ERR PQR"
            }
        }
        catch (error) {
            this.processResponse = false;
        }
        return this.processResponse;
    }
    genderType = (arg: any) => {
        let element = findInArray(this.genderList, 'id', arg);
        return getValue(element, 'name');
    }

    async downloadFile(file: File) {
        const arrayBuffer = await file.arrayBuffer();
        const fileName = file.name;
        const a = document.createElement('a')
        a.href = URL.createObjectURL(new Blob(
            [arrayBuffer],
            { type: file.type }
        ))
        a.download = fileName
        a.click();
        a.remove();
    }

}
